import { Button } from "@/components/ui/button"
import { useRelacaoPagamentos } from "../hooks/use-relacao-pagamentos"
import { ArrowLeft } from "lucide-react"
import { AppContainer } from "@/components/layout/app-container"
import FormRelacaoPagamentos from "../components/form-relacao-pagamentos"

export function RelacaoPagamentosForm() {
  const { projetos, projetoSelecionado, navigate } = useRelacaoPagamentos()

  const backButton = (
    <Button
      size="sm"
      variant="outline"
      className="border-gray-700 text-gray-300 hover:bg-gray-700"
      onClick={() => navigate("/financeiro/relacao-pagamentos")}
    >
      <ArrowLeft className="h-4 w-4 mr-2" />
      Voltar para Lançamentos
    </Button>
  )

  return (
    <AppContainer
      title={"Lançamento"}
      description="Agência Nacional do Cinema - Superintendência de Prestação de Contas"
      button={backButton}
    >
      <FormRelacaoPagamentos
        projetoSelecionado={projetoSelecionado}
        projects={projetos?.map(p => ({ id: p.id.toString(), name: p.name, salic_number: p.salic_number }))}
      />
    </AppContainer>
  )
}